import { h, Text } from "vue";
const getSlots = (parent, slots, defaultPayload, fallback) => {
  const fallbackSlot = fallback ? () => [h(Text, fallback)] : void 0;
  if (typeof parent === "string") {
    return slots.default ? slots.default(defaultPayload) : fallbackSlot == null ? void 0 : fallbackSlot();
  } else {
    if (slots.default) {
      const content = slots.default(defaultPayload);
      return {
        ...slots,
        default: content.length ? () => content : fallbackSlot
      };
    } else {
      return fallbackSlot;
    }
  }
};
export {
  getSlots
};
//# sourceMappingURL=getSlots.js.map
